import React from 'react';
import './NotFound.style.scss';
import { useNavigate } from 'react-router-dom';
import { RoutesNames } from '#/router/routes';

const NotFound = () => {
  const navigate = useNavigate();

  const goToHome = () => navigate(RoutesNames.HOME);
  return (
    <div className="notFound">
      <h1>Error 404 - Page not found</h1>
      <span onClick={goToHome}>Go to homepage</span>
    </div>
  );
};

export default React.memo(NotFound);
